import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetWarehousesParams,
    LocationGetCitiesGrouped,
    LocationGetCitiesResponse,
    LocationGetWarehouseResponse,
    LocationGetWarehousesResponse,
    LocationGetZonesResponse,
    WarehousesExportExcelResponse,
} from '@/new-services/types/location'

import {
    CreateWarehousePayload,
    UpdateWarehousePayload,
    UpdateWarehouseSchedulePayload,
    WarehousesExportExcelParams,
} from './types/tms'

type ApiCreateWarehouseResponse = Promise<AxiosResponse<void>>
type ApiUpdateDirectionTMSResponse = Promise<AxiosResponse<void>>
type ApiUpdateWarehouseScheduleTMSResponse = Promise<AxiosResponse<void>>
type ApiGetCitiesResponse = Promise<AxiosResponse<LocationGetCitiesResponse>>
type ApiGetWarehousesResponse = Promise<AxiosResponse<LocationGetWarehousesResponse>>
type ApiGetWarehouseResponse = Promise<AxiosResponse<LocationGetWarehouseResponse>>
type ApiGetZonesResponse = Promise<AxiosResponse<LocationGetZonesResponse>>
type ApiExportWarehousesExcelResponse = Promise<AxiosResponse<WarehousesExportExcelResponse>>
type ApiGetCitiesGroupedResponse = Promise<AxiosResponse<LocationGetCitiesGrouped>>

export function getWarehouses(params: GetWarehousesParams): ApiGetWarehousesResponse {
    return http.get('/location/api/warehouses', { params })
}

export function getWarehouse(id: number): ApiGetWarehouseResponse {
    return http.get(`/location/api/warehouses/${id}`)
}

export function getCities(statusId?: number, search?: string): ApiGetCitiesResponse {
    return http.get('/location/api/cities', { params: { statusId, search } })
}

export function getZones(): ApiGetZonesResponse {
    return http.get('/location/api/shipment-zones')
}

export function createWarehouse(payload: CreateWarehousePayload): ApiCreateWarehouseResponse {
    return http.post('/location/api/warehouses', payload)
}

export function updateWarehouse(
    id: number,
    payload: UpdateWarehousePayload
): ApiUpdateDirectionTMSResponse {
    return http.put(`/location/api/warehouses/${id}`, payload)
}

export function updateWarehouseSchedule(
    id: number,
    payload: UpdateWarehouseSchedulePayload
): ApiUpdateWarehouseScheduleTMSResponse {
    return http.put(`/location/api/warehouses/${id}/schedules`, payload)
}

export function exportWarehousesExcel(
    params: WarehousesExportExcelParams
): ApiExportWarehousesExcelResponse {
    return http.get('/location/api/warehouses/export', { responseType: 'blob', params })
}

export function getCitiesGrouped(): ApiGetCitiesGroupedResponse {
    return http.get('/location/api/cities-grouped')
}

export default {
    getCities,
    getZones,
    getWarehouses,
    getWarehouse,
    createWarehouse,
    updateWarehouse,
    updateWarehouseSchedule,
    exportWarehousesExcel,
    getCitiesGrouped,
}
